<template>
    <v-container fluid>
        <v-form v-model="valid">
            <ArticleEditContent :originalItem="null" :editItem="article" :editMode="true" :handleFocus="() => { }">
            </ArticleEditContent>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" :disabled="!valid" @click="create()">
                    {{ $t('servicesystem.common_objects.commonterms.create') }}
                </v-btn>
            </v-card-actions>
        </v-form>
    </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ArticleEditContent from './ArticleEditContent.vue';

export default {
    name: 'NewArticle',
    props: {},
    components: {
        ArticleEditContent,
    },
    data() {
        return {
            valid: false,
            article: {
                ArticleNumber: "",
                ArticleDescription: null,
                SalesText: null,
                PriceIn: null,
                Price: null,
                VatRate: null,
                IsStoreArticle: null,
                TechnicianSparePart: null,
                SupplierId: null,
            },
            createArticleLoading: false,
        };
    },

    methods: {
        async create() {
            this.createArticleLoading = true;
            var copy = Object.assign({}, this.article);
            const file = copy.newArticleImage;
            copy.newArticleImage = undefined;
            const dto = Object.assign({}, copy);
            await clientAPI.methods.createArticle(dto, file)
                .then((response) => {
                    this.$router.push({ name: 'ViewArticle', params: { articleId: response.Id, articleNumber: response.ArticleNumber } });
                })
                .finally(() => {
                    this.createArticleLoading = false;
                });
        }
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>